import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn, type RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

import { LocationActions } from './locations.actions';
import * as LocationSelectors from './locations.selectors';

export function locationStateResolverFactory(excludeArchived: boolean): ResolveFn<any> {
  return (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const locId = route.paramMap.get('locationId');
    const store = inject(Store);

    if (!locId) return;

    return store.select(LocationSelectors.locationState).pipe(
      tap(location => {
        if (!location || location.id !== locId) {
          store.dispatch(LocationActions.getLocationState({ excludeArchived, locationId: locId }));
        } else if (location) {
          store.dispatch(LocationActions.getLocationStateSuccess({ locationState: location }));
        }
      }),
    );
  };
}

export const locationStateResolver = locationStateResolverFactory(false);
export const mobileLocationStateResolver = locationStateResolverFactory(true);
